import AppendixForm from "../AppendixForm/AppendixForm";

export default function EditAppendixForm({ appendix, onClose }) {
	return <AppendixForm appendix={appendix} onClose={onClose} />;
}
